<template>
  <Modal v-model="editSubjectKeywordModal" :title="$t('configuration_management.mailbox_management.editEmailSubjectKeyword')" @on-ok="subjectKeywordSubmit('subjectKeywordEditForm')"
         @on-cancel="subjectKeywordReset('subjectKeywordEditForm')" :loading="loading" :mask-closable="false"
         :on-open-modal="editSubjectKeywordModal=true">
    <Form ref="subjectKeywordEditForm" :model="subjectKeywordEditForm" :label-width="100" :rules="ruleValidate">
      <!-- 邮件主题关键词 -->
      <FormItem :label="$t('configuration_management.mailbox_management.emailSubjectKeyword')" prop="keyword">
        <Input v-model="subjectKeywordEditForm.keyword" placeholder="Enter something..." style="width:300px;"></Input>
      </FormItem>

    </Form>
  </Modal>
</template>
<script>
  export default {
    name: 'EditSubjectKeyword',
    props: ['subjectKeywordEditOldForm'],
    data() {
      return {
        subjectKeywordEditForm: {
          id:0,
          keyword: ''
        },
        editSubjectKeywordModal: false,
        loading: true,
        ruleValidate: {
          keyword: [
            {required: true, message: this.$t('configuration_management.mailbox_management.subjectKeywordRequired'), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
      this.subjectKeywordShow();
    },
    methods: {
      // 公司列表
      listRegisterInformation: function () {
        this.$api.user.listRegisterInformation()
          .then(res => {
            // 获取公司列表数据
            this.companyIdList = res.data.companies;
          })
      },
      subjectKeywordShow: function () {
        this.$api.mailbox.select("id", this.subjectKeywordEditOldForm.id)
          .then(res => {
            this.subjectKeywordEditForm.id = res.data.id;
            this.subjectKeywordEditForm.keyword = res.data.keyword;
          })
      },
      subjectKeywordSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            this.$api.mailbox.update({
              "id": this.subjectKeywordEditForm.id,
              "keyword": this.subjectKeywordEditForm.keyword
            })
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  // 子组件引用父组件methods里面的方法
                  this.$parent.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t('common.addSuccess'));
                  this.$emit("on-close-cancel", false);
                  this.editSubjectKeywordModal = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });
      },
      subjectKeywordReset: function (name) {
        this.$emit("on-close-cancel", false);
        this.$refs[name].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/EditSubjectKeyword.vue